export const SESSION_STORAGE_LOCALES_KEY: string = "locales";

export const SESSION_STORAGE_LANGUAGE_KEY = "language";
